<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-height="965px"
    :max-width="isOsStlye.maxWidth"
  >
    <v-card id="tbVideoMeetingCreateDialog">
      <div class="dialog-container">
        <div class="dialog-header">
          <h3 class="header-title">영상회의 개설</h3>
          <div class="header-btn" style="margin-right: 30px;">
            <img
              style="cursor: pointer;"
              src="../../../src/images/button/query.png"
              @click="openBookmarkMeetingDialog()"
            />
            <img
              style="cursor: pointer; margin-left: 10px;"
              src="../../../src/images/button/saveConf.png"
              @click="openAddBookmarkMeetingDialog()"
            />
          </div>
        </div>
        <div class="dialog-body">
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">제목</div>
            </div>
            <div class="dialog-contents">
              <input
                type="text"
                style="font-size:15px;"
                placeholder="필수 입력"
                v-model="meeting.title"
              />
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">일시</div>
            </div>
            <div class="dialog-date-contents" style="position: relative">
              <div style="width: 104px; position: relative;">
                <input
                  class="styled-checkbox"
                  id="tbImmediateBtn"
                  type="checkbox"
                  style="z-index: 100; width: 100px; height: 30px; font-size:15px;"
                  v-model="immediateMeeting"
                />
                <label for="styled-checkbox-1">즉시회의</label>
              </div>

              <date-picker
                :disabled="isTimeFixed || immediateMeeting"
                :disabled-date="notBeforeToday"
                v-model="startDate"
                format="YYYY/MM/DD"
                value-type="format"
                :lang="lang"
                style="width: 140px; height: 40px; margin-right: 15px; font-size: 13px; cursor: pointer;"
              ></date-picker>
              <select
                class="formbox-time-select"
                v-model="startTime"
                @change="changedstartTime"
                :disabled="isTimeFixed || immediateMeeting"
                style="margin-right: 5px;"
              >
                <option
                  v-for="timeData in meetingTimeList"
                  :key="timeData"
                  :value="timeData"
                  >{{ timeData }}
                </option>
              </select>
              <span style="font-size:15px; margin-right: 5px;">~</span>
              <select
                class="formbox-time-select"
                v-model="endTime"
                @change="changedendTime"
                :disabled="isTimeFixed || immediateMeeting"
              >
                <option
                  v-for="timeData in meetingTimeList"
                  :key="timeData"
                  :value="timeData"
                  >{{ timeData }}
                </option>
              </select>
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">참석자</div>
            </div>
            <div class="dialog-public-contents">
              <input
                type="text"
                class="select-input cursor-pointer"
                style="font-size:15px; margin-left: 0;"
                placeholder="선택 사항"
                @click="openMeetingInvitaionDialog()"
                :value="attendeesString"
                readonly
              />
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">레이아웃</div>
            </div>
            <div style="width: 78%; display: flex; align-items: center;">
              <input
                type="text"
                class="select-input cursor-pointer"
                style="font-size:15px; margin-left: 25px;"
                v-bind:style="{ display: isInputLayout }"
                @click="openMeetingLayoutDialog()"
                placeholder="선택사항"
                readonly
              />
              <img
                class="fix-layout-img"
                :src="layoutFixSeatList.selectedLayoutImage"
                v-bind:style="{ display: isLayout }"
                @click="openMeetingLayoutDialog()"
              />
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">선택 옵션</div>
            </div>
            <div
              class="dialog-public-contents"
              style="flex-direction: column; align-items: start;"
            >
              <div
                style="position: relative; display: flex;  align-items: center;"
              >
                <input
                  type="checkbox"
                  id="video"
                  style="width: 150px; cursor: pointer; height: 25px;"
                  class="custom-radio conference-radio"
                  v-model="conferenceRoomActive"
                />
                <label class="custom-label conference-label" for="video"
                  >고화질 영상회의</label
                >

                <input
                  type="text"
                  class="select-input"
                  style="width:200px; font-size:15px; margin-left: 12px; padding-left: 10px;"
                  placeholder="선택사항"
                  :style="{ display: isRoomActive }"
                  :value="selectedConferenceRoomString"
                  @click="openMeetingConferenceDialog()"
                  readonly
                  
                  name="title"
                />
              </div>
              <div style="position: relative; margin-top: 8px;">
                <input
                  type="checkbox"
                  id="real"
                  class="custom-radio"
                  style="width: 150px; cursor: pointer; height: 24px;"
                  v-model="meetingLog"
                  :disabled="conferenceRoomActive"
                />
                <label class="custom-label" for="real">실시간 자막</label>
              </div>
              <div style="position: relative; margin-top: 8px;">
                <input
                  type="checkbox"
                  id="conference"
                  style="width: 150px; cursor: pointer; height: 24px;"
                  class="custom-radio"
                  v-model="allPublicMeeting"
                />
                <label class="custom-label" for="conference"
                  >전체 공개회의</label
                >
              </div>
              <div
                style="display:flex; align-items: center; position: relative; margin-top: 8px;"
              >
                <input
                  type="checkbox"
                  id="video"
                  style="width: 100px; cursor: pointer; height: 25px;"
                  class="custom-radio conference-radio"
                  v-model="meetingPublicType"
                />
                <label class="custom-label conference-label" for="video"
                  >비밀번호</label
                >

                <input
                  :style="{ display: isPrivate }"
                  type="password"
                  placeholder="비밀번호를 입력하세요"
                  class="select-input"
                  style="margin-left: 12px;"
                  v-model="meeting.password"
                />
              </div>
            </div>
          </div>
          <div class="is-ipad" style="height: 50px;"></div>
          <div class="dialog-footer">
            <button class="dialog-cancelBtn" @click="close">취소</button>
            <button class="dialog-okBtn" @click="createMeeting">개설</button>
          </div>
        </div>
      </div>
    </v-card>
    <!-- <meeting-type-dialog
      :dialog="meetingTypeDialog.dialog"
      :attendeesInfo="meetingTypeDialog.attendees"
      :close="closeMeetingTypeDialog"
    /> -->
    <meeting-conference-dialog
      :dialog="meetingConferenceDialog.dialog"
      :meetingInfo="meeting"
      :conferenceRooms="meetingConferenceDialog.conferenceRooms"
      :closeDialog="closeMeetingConferenceDialog"
      @selectedConferenceRooms="selectedConferenceRooms"
    />

    <tb-meeting-invitaion-dialog
      :dialog="meetingInvitaionDialog.dialog"
      :exMeeting="exMeeting"
      :attendeesInfo="meetingInvitaionDialog.attendees"
      :closeMeetingInvitaionDialog="closeMeetingInvitaionDialog"
    />

    <meeting-layout-dialog
      :dialog="meetingLayoutDialog.dialog"
      @selectedFixSeatList="selectedFixSeatList"
      :attendees="meetingLayoutDialog.attendees"
      :meeetingFixSeatList="meetingLayoutDialog.fixSeatList"
      :selectLayoutCode="meetingLayoutDialog.selectLayoutCode"
      :conferenceRoomActive="conferenceRoomActive"
      @closeMeetingLayoutDialog="closeMeetingLayoutDialog"
    />

    <conference-agree-dialog
      :dialog="conferenceAgreeDialog.dialog"
      :closeDialog="closeConferenceAgreeDialog"
    />

    <!-- 회의 불러오기 보기 -->
    <bookmark-meeting-dialog
      :dialog="bookmarkMeetingDialog.dialog"
      @selectedBookmarkMeeting="selectedBookmarkMeeting"
      :closeDialog="closeBookmarkMeetingDialog"
    />

    <!-- 회의 저장 -->
    <add-bookmark-meeting-dialog
      :dialog="addBookmarkMeetingDialog.dialog"
      :meetingInfo="addBookmarkMeetingDialog.meetingInfo"
      :closeDialog="closeAddBookmarkMeetingDialog"
    />

    <!-- 안내문구 -->
    <guide-log-dialog
      :dialog="guideLogDialog.dialog"
      :guideContents="guideLogContents"
      :closeDialog="closeGuideLogDialog"
    />

    <!-- 녹화문구 -->
    <rec-log-dialog
      :dialog="recLogDialog.dialog"
      :recContents="recLogContents"
      :closeDialog="closeRecLogDialog"
    />
  </v-dialog>
</template>
<script>
import Util from '@/util';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import MeetingCreate from '@/components/meeting/MeetingCreate';
/* import MeetingTypeDialog from '@/components/popup/MeetingTypeDialog'; */
import MeetingConferenceDialog from '@/components/popup/MeetingConferenceDialog';
import moment from 'moment';
import timezone from 'moment-timezone';
import TbMeetingInvitaionDialog from '@/components/popup/TbMeetingInvitaionDialog';
import BookmarkMeetingDialog from '@/components/popup/BookmarkMeetingDialog';
import AddBookmarkMeetingDialog from '@/components/popup/AddBookmarkMeetingDialog';
import GuideLogDialog from '@/components/popup/GuideLogDialog';
import RecLogDialog from '@/components/popup/RecLogDialog';
import MeetingLayoutDialog from '@/components/popup/MeetingLayoutDialog';
import ConferenceAgreeDialog from '@/components/popup/ConferenceAgreeDialog';

export default {
  filters: {
    conferenceDayFilter: function(day) {
      if (day === null) {
        return moment().format('YYYY / MM / DD');
      } else {
        return moment(day).format('YYYY / MM / DD');
      }
    },
    conferenceTimeFilter: function(time) {
      return moment(time).format('HH시 mm분');
    },
    textLengthOverCut(txt, len, lastTxt) {
      if (len === '' || len === null) {
        len = 5;
      }
      if (lastTxt === '' || lastTxt === null) {
        lastTxt = '...';
      }
      console.log(txt.length);
      console.log(len);
      if (txt.length > len) {
        txt = txt.substr(0, len) + lastTxt;
        console.log(txt);
      }
      return txt;
    },
  },
  components: {
    MeetingCreate,
    DatePicker,
    /* MeetingTypeDialog, */
    MeetingConferenceDialog,
    TbMeetingInvitaionDialog,
    MeetingLayoutDialog,
    BookmarkMeetingDialog,
    AddBookmarkMeetingDialog,
    ConferenceAgreeDialog,
    GuideLogDialog,
    RecLogDialog,
  },
  props: [
    'dialog',
    'closeDialog',
    'meetingInfo',
    'isTimeFixed',
    'isRoomSelectable',
    'isAdminPage',
    'mode',
  ],
  data() {
    return {
      allPublicMeeting: false,
      lang: {
        days: ['일', '월', '화', '수', '목', '금', '토'],
        months: [
          '1월',
          '2월',
          '3월',
          '4월',
          '5월',
          '6월',
          '7월',
          '8월',
          '9월',
          '10월',
          '11월',
          '12월',
        ],
        yearFormat: 'YYYY년',
        monthFormat: 'MM월',
        // the calendar title of month before year
        monthBeforeYear: false,
      },
      pickrFormat: 'YYYY.MM.DD',
      max: 4,
      minDate: new Date().toISOString().substr(0, 10),
      startDate: new Date().toISOString().substr(0, 10),
      isHelpActive: 'none',

      startTime: null,
      endTime: null,
      loading: true,
      attendeesString: null,
      selectedConferenceRoomString: null,
      meetingBookmarkImage: '/static/seoul/img/bookmark_off.png',
      meetingBookmarkActive: false,
      meetingLogActive: false,
      isOsStlye: {
        maxWidth: '630px',
        marginLeft: 0,
      },
      meetingTypeDialog: {
        dialog: false,
        attendees: [],
      },
      meetingConferenceDialog: {
        dialog: false,
        conferenceRooms: [],
      },
      meetingLayoutDialog: {
        dialog: false,
        attendees: [],
        fixSeatList: [],
        selectLayoutCode: null,
      },
      meetingInvitaionDialog: {
        dialog: false,
        attendees: [],
      },
      conferenceAgreeDialog: {
        dialog: false,
      },
      bookmarkMeetingDialog: {
        dialog: false,
      },
      addBookmarkMeetingDialog: {
        dialog: false,
        meetingInfo: {},
      },
      guideLogDialog: {
        dialog: false,
      },
      recLogDialog: {
        dialog: false,
      },
      addBookmarkMeetingBtn: false,
      layoutFixSeatList: {
        selectedLayoutCode: null,
        selectedLayoutImage: null,
      },
      isPrivate: 'none',
      meetingType: 'general',
      conferenceRoomActive: false,
      meetingPublicType: false,
      isActive: 'none',
      isRoomActive: 'none',
      isActiveStartTime: 'none',
      isInputLayout: '',
      isLayout: 'none',
      guideLog: null,
      recLog: null,
      exMeeting: false,
      meetingLog: null,
      agreeConference: null,
      meetingBanner: false,
      bannerPosition: 'bannerTop',
      meetingBannerActive: 'none',
      defaultMeeting: {
        email: null,
        title: null,
        startTime: null,
        endTime: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        meetingRoom: null,
        meetingRoomId: null,
        roomIds: [],
        password: null,
      },
      editedMeetingInfo: {},
      meeting: {
        email: null,
        title: null,
        startTime: null,
        endTime: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        roomIds: [],
        password: null,
      },
      error: null,
      immediateMeeting: false,
      repeatSetting: false,
      meetingTimeList: [],
      selectedConferenceRoom: null,
      selectedConferenceRoomArr: [],
      guideLogContents: null,
      recLogContents: null,
    };
  },
  computed: {
    nowHour() {
      let hh = moment().format('HH');
      let mm = moment().format('mm');

      let setHour = '';

      if (mm < 30) {
        setHour = moment().format('YYYY-MM-DDTHH:mm:ss');
      } else {
        setHour = moment()
          .add('1', 'h')
          .format('YYYY-MM-DDTHH:00:00');
      }

      return setHour;
    },
    reserveHour() {
      let time = this.meeting.startTime;
      if (time !== null) {
        if (time !== '') {
          let hh = time.split('T')[1].split(':')[0];
          let mm = time
            .split('T')[1]
            .split(':')[1]
            .split(':')[0];

          let setHour = '';
          if (mm === 30) {
            hh = parseInt(hh, 10) + 1;
            setHour = moment().format('YYYY-MM-DDT' + hh + ':00:ss');
          } else {
            setHour = moment()
              .add('30', 'm')
              .format('YYYY-MM-DDT' + hh + ':30:ss');
          }

          return setHour;
        }
      }
    },
    getMaxDateTime() {
      return null;
    },
  },
  watch: {
    dialog: {
      handler(val) {
        if (val) {
          this.editedMeetingInfo = Object.assign({}, this.meetingInfo);
          this.loading = false;
          this.initMeeting();
        }
      },
    },
    guideLog() {
      if (this.guideLog === true) {
        this.guideLogDialog.dialog = true;
      } else {
        this.guideLogDialog.dialog = false;
      }
    },
    recLog() {
      if (this.recLog === true) {
        this.recLogDialog.dialog = true;
      } else {
        this.recLogDialog.dialog = false;
      }
    },
    agreeConference() {
      if (this.agreeConference === true) {
        alert(
          '본 시스템은 서울시, 자치구 및 투자출연기관의 업무 목적에 따라 영상회의 개설이 가능하며, 개설자는 사적 이용 시 민, 형사적 책임을 질 수 있음을 확인 합니다.'
        );
      }
    },
    conferenceRoomActive() {
      this.meetingLog = false;

      if (this.conferenceRoomActive === true) {
        this.isRoomActive = '';
        this.meetingLayoutDialog.selectLayoutCode = null;
        this.layoutFixSeatList.selectedLayoutCode = null;
        this.layoutFixSeatList.selectedLayoutImage = null;
        this.isInputLayout = '';
        this.isLayout = 'none';
      } else {
        this.isRoomActive = 'none';
        this.meetingLayoutDialog.selectLayoutCode = null;
        this.layoutFixSeatList.selectedLayoutCode = null;
        this.layoutFixSeatList.selectedLayoutImage = null;
        this.isInputLayout = '';
        this.isLayout = 'none';

        this.meetingConferenceDialog.conferenceRooms = [];
      }
    },
    meetingPublicType() {
      if (this.meetingPublicType === true) {
        this.isPrivate = '';
      } else {
        this.isPrivate = 'none';
        this.meeting.password = '';
      }
    },
    immediateMeeting: function(val) {
      /* 즉시회의 여기서 작업하시면 됩니다. */
      this.isTimeFixed = true;
      this.immediateChange(val);
      this.editedMeetingInfo.selectStartTime = moment().format('YYYY/MM/DD');
    },
    meetingBanner() {
      this.meetingBanner
        ? (this.meetingBannerActive = '')
        : (this.meetingBannerActive = 'none');
    },
  },
  mounted() {},
  methods: {
    prepareService() {
      alert('준비중인 서비스입니다.');
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    initMeeting() {
      // 반응형 작업
      let os = Util.getOS();
      console.log(`exMeeting : `, this.exMeeting);
      if (os.indexOf('window') !== -1) {
        this.isOsStlye.maxWidth = '750px';
      }
      // this.isOsStlye.maxWidth;

      this.startDate = moment().format('YYYY/MM/DD');

      this.meetingBookmarkActive = false;
      this.conferenceRoomActive = false;
      this.immediateMeeting = false;

      this.meetingBookmarkImage = '/static/seoul/img/bookmark_off.png';
      this.meeting.title = null;
      this.meeting.startTime = null;
      this.meeting.endTime = null;
      this.meeting.attendees = [];
      this.meetingInvitaionDialog.attendees = [];
      this.meeting.password = null;
      this.meetingPublicType = false;
      this.isPrivate = 'none';
      this.error = null;
      this.guideLog = false;
      this.guideLogContents = null;
      this.recLog = false;
      this.agreeConference = false;
      this.recLogContents = null;
      this.exMeeting = false;
      this.allPublicMeeting = false;
      /* 영상회의실 */
      this.selectedConferenceRoomString = null;
      this.meetingConferenceDialog.conferenceRooms = [];

      this.layoutFixSeatList.fixSeatList = [];
      this.meetingLayoutDialog.selectLayoutCode = null;

      /* 참석자 */
      this.attendeesString = null;

      /* 실시간 회의록 */
      this.meetingLog = false;
      this.meetingBanner = false;
      this.bannerPosition = 'bannerTop';
      this.meeting.email = this.$store.state.user.email;
      this.isLayout = 'none';
      this.isActive = 'none';
      this.initTimeData();
      let meetingRoom = null;
      let meetingRoomId = null;
      this.isInputLayout = '';
      this.meetingLayoutDialog.selectLayoutCode = null;
      if (this.$parent.meetingInfo) {
        meetingRoom = this.$parent.meetingInfo.selectRoom;
        meetingRoomId = this.$parent.meetingInfo.selectRoomId;
      }

      if (meetingRoom !== null && meetingRoom !== undefined) {
        this.selectedConferenceRoomArr.push(meetingRoom);
        this.selectedConferenceRoom = meetingRoom;
        this.selectedConferenceRoomId = meetingRoomId;
      }

      $('input[class=mx-input]').attr('readonly', true);
    },
    initTimeData() {
      this.meetingTimeList = [];
      let meetingInterval = 10;
      let time = moment();
      let staDate = moment(time.format('YYYY/MM/DD'));
      let endDate = time
        .clone()
        .add(1, 'day')
        .format('YYYY/MM/DD');

      for (
        let now = new Date(),
          start = new Date(now.setHours(0, 0, 0, 0)),
          end = new Date(now.setDate(now.getDate() + 1));
        start < end;
        start.setMinutes(start.getMinutes() + 10)
      ) {
        this.meetingTimeList.push(start.toTimeString().slice(0, 5));
        //console.log(start.toTimeString().slice(0, 5));
      }
      // while (staDate.format("YYYY/MM/DD") < endDate) {
      //   this.meetingTimeList.push(staDate.format("HH:mm"));
      //   staDate = staDate.add(meetingInterval, "minutes");

      //   if (endDate) {
      //     break;
      //   }
      // }

      // 초기 시간 선택
      if (
        this.meetingInfo.selectStartTime !== null &&
        this.meetingInfo.selectEndTime
      ) {
        this.meeting.startTime = this.meetingInfo.selectStartTime;
        this.meeting.endTime = this.meetingInfo.selectEndTime;
        this.startTime = moment(this.meeting.startTime).format('HH:mm');
        this.endTime = moment(this.meeting.endTime).format('HH:mm');
      } else {
        let nearestFuture = Util.nearestFutureMinutes(meetingInterval, time);
        if (this.immediateMeeting) {
          this.startTime = this.$t('page.meeting-reserve.immediate');
        } else {
          this.startTime = nearestFuture.format('HH:mm');
        }
        this.endTime = nearestFuture.add(30, 'minutes').format('HH:mm');
      }

      this.meeting.startTime = moment
        .tz(this.startDate + ' ' + this.startTime, moment.tz.guess())
        .utc()
        .format();
      this.meeting.endTime = moment
        .tz(this.startDate + ' ' + this.endTime, moment.tz.guess())
        .utc()
        .format();
    },
    openMeetingTypeDialog() {
      /* 미팅 유형 선택 팝업 */
      this.meetingTypeDialog.dialog = true;
    },
    openMeetingConferenceDialog() {
      let startDtime = moment
        .tz(this.startDate + ' ' + this.startTime, moment.tz.guess())
        .utc()
        .format();
      let endDtime = moment
        .tz(this.startDate + ' ' + this.endTime, moment.tz.guess())
        .utc()
        .format();

      this.meeting.startDtime = startDtime;
      this.meeting.endDtime = endDtime;
      this.meetingConferenceDialog.dialog = true;
    },
    closeMeetingConferenceDialog() {
      this.meetingConferenceDialog.dialog = false;
    },
    closeConferenceAgreeDialog() {
      this.conferenceAgreeDialog.dialog = false;
    },
    close(isInit) {
      if (this.$parent.meetingInfo) {
        this.$parent.meetingInfo.selectRoom = null;
      }

      this.selectedConferenceRoom = null;
      this.selectedConferenceRoomArr = [];
      this.allPublicMeeting = false;
      this.immediateMeeting = false;
      // this.initMeeting();
      this.closeDialog(isInit);
      this.initMeeting();
      this.layoutFixSeatList.selectedLayoutCode = null;
      this.layoutFixSeatList.selectedLayoutImage = null;
    },
    showDatePicker() {
      if (!this.immediateMeeting) {
        if (this.isActive === 'none') {
          this.isActive = '';
        } else {
          this.isActive = 'none';
        }
      }
    },
    startDateChange() {
      this.isActive = 'none';
      this.editedMeetingInfo.selectStartTime = this.startDate;
    },
    showStartTimePicker() {
      if (this.isActiveStartTime === 'none') {
        this.isActiveStartTime = '';
      } else {
        this.isActiveStartTime = 'none';
      }
    },
    changedstartTime() {
      console.log(`changedstartTime`);
    },
    changedendTime() {
      console.log(`changedendTime`);
    },
    createMeeting() {
      let startDtime = moment
        .tz(this.startDate + ' ' + this.startTime, moment.tz.guess())
        .utc()
        .format();
      let endDtime = moment
        .tz(this.startDate + ' ' + this.endTime, moment.tz.guess())
        .utc()
        .format();

      this.meeting.startDtime = startDtime;
      this.meeting.endDtime = endDtime;

      const areAllFieldsFilledIn = Object.keys(this.meeting).every((key) => {
        if (
          key === 'attendees' ||
          key === 'startTime' ||
          key === 'endTime' ||
          key === 'password' ||
          key === 'meetingRoom' ||
          key === 'meetingRoomId' ||
          key === 'notice'
        )
          return true;
        return !!this.meeting[key];
      });
      if (!areAllFieldsFilledIn) {
        Util.snackBarOpen('회의제목을 입력하시기 바랍니다.', 'error');
        this.error = '필수 값이 입력되지 않았습니다.';
        return;
      }

      if (this.meetingPublicType === true) {
        if (this.meeting.password === null) {
          Util.snackBarOpen('비밀번호를 입력하시기 바랍니다.', 'error');
          return;
        }
      }

      if (
        this.meeting.startDtime >= this.meeting.endDtime &&
        !this.immediateMeeting
      ) {
        if (
          this.editedMeetingInfo.startDtime === this.editedMeetingInfo.endDtime
        ) {
          Util.snackBarOpen(
            '시작일시와 종료일시가 같을 수 없습니다. 정확한 정보를 입력해주세요',
            'error'
          );
          return;
        } else {
          Util.snackBarOpen(
            '시작일시가 종료일시보다 늦습니다. 정확한 정보를 입력해주세요',
            'error'
          );
          this.error =
            '시작일시가 종료일시보다 늦습니다. 정확한 정보를 입력해주세요';
          return;
        }
      }

      if (
        moment(new Date()).format('YYYY/MM/DD') === this.startDate &&
        moment(new Date()).format('HH:mm') >= this.startTime &&
        !this.immediateMeeting
      ) {
        Util.snackBarOpen(
          '지난 시간입니다. 현재 시간 이후로 예약이 가능합니다.',
          'error'
        );
        return;
      }

      let now = moment()
        .utc()
        .format();
      if (now >= endDtime && this.immediateMeeting) {
        Util.snackBarOpen('예약시간 설정 오류', 'error');
        return;
      }

      if (this.conferenceRoomActive === true) {
        if (this.selectedConferenceRoomArr.length === 0) {
          Util.snackBarOpen('영상회의실을 추가해주세요', 'error');
          return;
        }
      } else {
        this.selectedConferenceRoomArr = null;
      }

      this.loading = true;
      let layoutCode = '';
      let fixSeatList = '';
      let saehaLayoutCode = '';
      let openOption = '';
      if (this.layoutFixSeatList.selectedLayoutCode !== null) {
        switch (this.layoutFixSeatList.selectedLayoutCode) {
          case 'lay1':
            saehaLayoutCode = '4';
            break;
          case 'lay2':
            saehaLayoutCode = '6';
            break;
          case 'lay3':
            saehaLayoutCode = '7';
            break;
          case 'lay4':
            saehaLayoutCode = '8';
            break;
          case 'lay5':
            saehaLayoutCode = '9';
            break;
          case 'lay6':
            saehaLayoutCode = '10';
            break;
          case 'lay7':
            saehaLayoutCode = '11';
            break;
          case 'lay8':
            saehaLayoutCode = '13';
            break;
          case 'lay9':
            saehaLayoutCode = '14';
            break;
          case 'lay10':
            saehaLayoutCode = '15';
            break;
          case 'lay11':
            saehaLayoutCode = '18';
            break;
          case 'lay12':
            saehaLayoutCode = '19';
            break;
          case 'lay13':
            saehaLayoutCode = '20';
            break;
          case 'lay14':
            saehaLayoutCode = '22';
            break;
        }
        layoutCode = '12849=0,' + saehaLayoutCode;

        if (
          this.layoutFixSeatList.fixSeatList &&
          this.layoutFixSeatList.fixSeatList.length > 0
        ) {
          fixSeatList += '12888=';

          let seats = this.layoutFixSeatList.fixSeatList
            .filter((fixSeat) => fixSeat.seat !== null)
            .map((fixSeat) => {
              return (
                '0,' +
                (fixSeat.id - 1) +
                ',0,' +
                fixSeat.seat.split('#')[0] +
                ',' +
                fixSeat.seat.split('#')[1]
              );
            });
          console.log(seats);
          fixSeatList += seats.join('|');
          openOption = layoutCode + '&' + fixSeatList;
        } else {
          openOption = layoutCode;
        }
      }

      if (this.meeting.attendees === undefined) {
        this.meeting.attendees = [];
      }
      // +9시간이 안돼서 갑자기 추가하게 됨 (추후 변경)

      if (this.meeting.startDtime === 'Invalid date') {
        this.meeting.startDtime = moment(new Date()).format('YYYY/MM/DD HH:mm');
        this.meeting.startDtime = moment
          .tz(this.meeting.startDtime, moment.tz.guess())
          .utc()
          .format();
      }
      // +9시간이 안돼서 갑자기 추가하게 됨 (추후 변경)
      let insertStartDtime = moment(this.meeting.startDtime).format(
        'YYYY/MM/DD HH:mm'
      );

      let insertEndDtime = moment(this.meeting.endDtime).format(
        'YYYY/MM/DD HH:mm'
      );

      let meetingInfo = {
        creator: {
          email: this.meeting.email,
        },
        title: this.meeting.title,
        startDtime:
          new Date(insertStartDtime).toISOString().split('.')[0] + 'Z',
        endDtime: new Date(insertEndDtime).toISOString().split('.')[0] + 'Z',
        attendees: this.meeting.attendees,
        password: this.meeting.password,
        isImmediately: this.immediateMeeting,
        conferenceRoomActive: this.conferenceRoomActive,
        selectedConferenceRoomArr: this.selectedConferenceRoomArr,
        layoutFixSeatList: this.layoutFixSeatList,
        roomOption: openOption, //roomOption
        meetingLog: this.meetingLog,
        meetingBanner: this.meetingBanner,
        bannerPosition: this.bannerPosition,
        meetingBookmarkActive: this.meetingBookmarkActive,
        notice: this.meeting.notice,
        exMeeting: this.exMeeting,
        allPublicMeeting: this.allPublicMeeting,
      };

      // DMZ망 미팅 예약
      if (this.exMeeting === true) {
        this.$http
          .post('/api/v1/meetings/createExMeeting', meetingInfo)
          .then((response) => {
            let result = response.data;
            if (this.immediateMeeting) {
              /* 즉시 회의의 경우 바로 참석 */
              this.closeDialog();
              Util.snackBarOpen('영상회의 예약 완료', 'success');
              let item = {
                me: {
                  email: this.$store.state.user.email,
                  displayName: this.$store.state.user.name
                    ? this.$store.state.user.name
                    : this.$store.state.user.email, // this.$store.state.user.displayFullName ? this.$store.state.user.displayFullName : this.$store.state.user.username
                },
              };
              let params = {
                me: item.me,
                coSpaceUri: result.data.meetingKey,
                email: this.$store.state.user.email,
              };

              if (this.conferenceRoomActive === true) {
                console.log('#DMZ망 CMS 회의');
                // CMS 미팅인 경우
                this.$http
                  .get(`/api/auth/dmzSaehaInfo`, { params: params })
                  .then((response) => {
                    let info = response.data;
                    console.log(`info : `, info);
                    const ds = this.$BodaApp.defaultSettings(info.ds);
                    this.$BodaApp.openJoin(
                      {
                        roomCode: info.oj.roomCode,
                        template: Number(info.oj.template),
                        title:
                          this.meeting.title +
                          '     회의방 번호:  ' +
                          info.oj.roomCode,
                        userType: 1,
                        userId: info.userData.userId,
                        userName:
                          info.userData.userName + `/${info.userData.userId}`,
                        openOption: info.oj.openOption,
                        joinOption: info.oj.joinOption,
                        appOption: { Q: { QSchm: 'krxflow://' } },
                      },
                      () => {
                        console.log('success');
                        this.$emit('createdMeeting', ret);
                        this.meeting = Object.assign({}, this.defaultMeeting);
                        this.initMeeting();
                      },
                      (errorCode, reason) => {
                        console.log(errorCode, reason);
                        this.loading = false;
                      }
                    );

                    this.loading = false;
                  })
                  .catch((err) => {
                    console.log(err);
                    this.loading = false;
                  });
              } else {
                console.log('# 외부망 일반회의 #');
                this.$http
                  .get(`/api/auth/joinUrlForDmzSaehaInfo`, {
                    params: params,
                  })
                  .then((response) => {
                    let info = response.data;
                    console.log(info);
                    const ds = this.$BodaApp.defaultSettings(info.ds);
                    console.log(ds);
                    // let templateCode = Number(info.oj.template);

                    this.$BodaApp.openJoin(
                      {
                        roomCode: info.meetingInfo.meetingKey,
                        template: this.meetingLog ? 168 : 163,
                        title:
                          this.meeting.title +
                          '     회의방 번호:  ' +
                          info.meetingInfo.meetingKey,
                        userType: 1,
                        userId: info.userData.userId,
                        userName: info.userData.userName,
                        openOption: openOption,
                        appOption: { Q: { QSchm: 'krxflow://' } },
                      },
                      () => {
                        console.log('success');
                        this.$emit('createdMeeting', ret);
                        this.meeting = Object.assign({}, this.defaultMeeting);
                        this.initMeeting();
                      },
                      (errorCode, reason) => {
                        console.log(errorCode, reason);
                        if (
                          errorCode === 'BODA-NOT_INSTALLED' ||
                          errorCode === 'BODA-NOT_CONNECTED_AGENT'
                        ) {
                          this.$BodaApp.downloadClient(
                            {},
                            function() {
                              // 성공 시 처리
                            },
                            function(errorCode, reason) {
                              // 오류 시 처리
                            }
                          );
                        } else if (errorCode === 'BODA-UNDEFINED_ERROR') {
                          if (reason === 'CLIENT_RUNNING') {
                            alert(
                              '영상회의 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요.'
                            );
                          }
                        }
                        this.loading = false;
                      }
                    );
                    this.loading = false;
                  })
                  .catch((err) => {
                    console.log(err);
                    this.loading = false;
                  });
              }
            } else {
              this.close(true);
              Util.snackBarOpen('영상회의 예약 완료', 'success');
              this.$emit('createdMeeting', ret);
              this.meeting = Object.assign({}, this.defaultMeeting);
              this.initMeeting();
            }
          });
      } else {
        //내부망 미팅

        this.$http
          .post('/api/v1/meetings/createMeeting', meetingInfo)
          .then((response) => {
            let ret = response.data;
            if (this.conferenceRoomActive && !this.immediateMeeting) {
              this.initMeeting();
              this.close(true);
              return;
            }

            this.loading = false;
            if (typeof ret === 'string') {
              this.error = ret;
            } else {
              let meetingInfo = response.data.data;

              if (this.immediateMeeting) {
                /* 즉시 회의의 경우 바로 참석 */
                this.closeDialog();
                Util.snackBarOpen(this.$t('영상회의 예약 완료'), 'success');

                let item = {
                  me: {
                    email: this.$store.state.user.email,
                    displayName: this.$store.state.user.name
                      ? this.$store.state.user.name
                      : this.$store.state.user.email, // this.$store.state.user.displayFullName ? this.$store.state.user.displayFullName : this.$store.state.user.username
                  },
                };
                let params = {
                  _id: meetingInfo._id,
                  me: item.me,
                  email: this.$store.state.user.email,
                  coSpaceUri: meetingInfo.meetingKey,
                };
                if (this.conferenceRoomActive === true) {
                  console.log('내부망 CMS미팅');
                  // CMS 미팅인 경우
                  this.$http
                    .get(`/api/auth/saehaInfo`, { params: params })
                    .then((response) => {
                      let info = response.data;
                      console.log(info);
                      const ds = this.$BodaApp.defaultSettings(info.ds);
                      this.$BodaApp.openJoin(
                        {
                          roomCode: info.oj.roomCode,
                          template: Number(info.oj.template),
                          title:
                            this.meeting.title +
                            '     회의방 번호:  ' +
                            info.oj.roomCode,
                          userType: 1,
                          userId: info.userData.userId,
                          userName:
                            info.userData.userName + `/${info.userData.userId}`,
                          openOption: info.oj.openOption,
                          joinOption: info.oj.joinOption,
                          appOption: { Q: { QSchm: 'krxflow://' } },
                        },
                        () => {
                          console.log('success');
                          this.$emit('createdMeeting', ret);
                          this.meeting = Object.assign({}, this.defaultMeeting);
                          this.initMeeting();
                        },
                        (errorCode, reason) => {
                          console.log(errorCode, reason);
                          this.loading = false;
                        }
                      );

                      this.loading = false;
                    })
                    .catch((err) => {
                      console.log(err);
                      this.loading = false;
                    });
                } else {
                  console.log('내부망 일반회의');
                  this.$http
                    .get(`/api/auth/joinUrlForSaehaInfo`, {
                      params: params,
                    })
                    .then((response) => {
                      let info = response.data;
                      const ds = this.$BodaApp.defaultSettings(info.ds);
                      // let templateCode = Number(info.oj.template);

                      this.$BodaApp.openJoin(
                        {
                          roomCode: info.meetingKey,
                          template: this.meetingLog ? 168 : 163,
                          title:
                            info.meetingTitle +
                            '     회의방 번호:  ' +
                            info.meetingKey,
                          userType: 1,
                          userId: info.userData.userId,
                          userName: info.userData.userName,
                          openOption: openOption,
                          appOption: { Q: { QSchm: 'krxflow://' } },
                        },
                        () => {
                          console.log('success');
                          this.$emit('createdMeeting', '');
                          this.meeting = Object.assign({}, this.defaultMeeting);
                          this.initMeeting();
                        },
                        (errorCode, reason) => {
                          console.log(errorCode, reason);
                          if (
                            errorCode === 'BODA-NOT_INSTALLED' ||
                            errorCode === 'BODA-NOT_CONNECTED_AGENT'
                          ) {
                            this.$BodaApp.downloadClient(
                              {},
                              function() {
                                // 성공 시 처리
                              },
                              function(errorCode, reason) {
                                // 오류 시 처리
                              }
                            );
                          } else if (errorCode === 'BODA-UNDEFINED_ERROR') {
                            if (reason === 'CLIENT_RUNNING') {
                              alert(
                                '영상회의 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요.'
                              );
                            }
                          }
                          this.loading = false;
                        }
                      );
                      this.loading = false;
                    })
                    .catch((err) => {
                      console.log(err);
                      this.loading = false;
                    });
                }
              } else {
                this.close(true);
                Util.snackBarOpen('영상회의 예약 완료', 'success');
                this.$emit('createdMeeting', ret);
                this.meeting = Object.assign({}, this.defaultMeeting);
                this.initMeeting();
              }
            }
          })
          .catch((error) => {
            this.error = error.response.data.error;
          });
      }
    },
    async deleteMeeting() {
      // 미팅 삭제
      let params = {
        meetingKeys: [this.meetingInfo.meetings.meetingKey],
      };
      await this.$http
        .delete('/api/v1/meetings', { params: params })
        .then((response) => {
          if (response.data === 'ok') {
            this.close(true);
            Util.snackBarOpen('회의 삭제 완료', 'success');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectedConferenceRooms(selectedConferenceRooms) {
      let rooms = '';
      this.selectedConferenceRoomArr = [];
      if (selectedConferenceRooms.length !== 0) {
        this.meetingConferenceDialog.conferenceRooms = selectedConferenceRooms;
        for (let i = 0; i < selectedConferenceRooms.length; i++) {
          this.meeting.roomIds.push(selectedConferenceRooms[i]._id);
          if (i === selectedConferenceRooms.length - 1) {
            rooms += selectedConferenceRooms[i].deviceName;
          } else {
            rooms += selectedConferenceRooms[i].deviceName + ', ';
          }
          this.selectedConferenceRoomArr.push(selectedConferenceRooms[i]);
        }
        if (this.selectedConferenceRoomArr.length > 1) {
          this.selectedConferenceRoomString =
            this.selectedConferenceRoomArr[0].deviceName +
            '외 ' +
            parseInt(this.selectedConferenceRoomArr.length - 1);
        } else {
          this.selectedConferenceRoomString = this.selectedConferenceRoomArr[0].deviceName;
        }
      } else {
        this.meetingConferenceDialog.conferenceRooms = [];
        this.selectedConferenceRoomString = null;
      }
    },
    immediateChange(immediate) {
      this.isActive = 'none';
      if (immediate) {
        // 시작 시간 => 즉시로 변경
        // 시작 날짜 => 오늘로 변경
        this.meetingTimeList.unshift(this.$t('page.meeting-reserve.immediate'));
        console.log(`?? : `, this.meetingTimeList);
        this.startTime = this.meetingTimeList[0];
        this.startDate = moment().format('YYYY/MM/DD');
        this.startDate = moment().format('YYYY/MM/DD');

        let meetingInterval = 10;
        let time = moment();
        let nearestFuture = Util.nearestFutureMinutes(meetingInterval, time);
        this.endTime = nearestFuture.add(30, 'minutes').format('HH:mm');
      } else {
        this.initTimeData();
        this.isTimeFixed = false;
      }
    },
    deleteConferenceRoom(index) {
      this.selectedConferenceRoomArr.splice(index, 1);
    },
    changeMeetingPublicType() {
      if (this.meetingPublicType === 'public') {
        this.isPrivate = 'none';
        this.meeting.password = null;
      } else {
        this.isPrivate = '';
      }
    },
    changeMeetingType() {
      if (this.meetingType === 'general') {
        this.meetingType = 'general';
        this.attendeesString = this.$t('page.meeting-reserve.attendee-list');
      } else {
        this.meetingType = 'article';
        this.attendeesString = this.$t(
          'page.meeting-reserve.attendee-list-type2'
        );
      }
    },
    openBookmarkMeetingDialog() {
      this.bookmarkMeetingDialog.dialog = true;
    },
    closeBookmarkMeetingDialog() {
      this.bookmarkMeetingDialog.dialog = false;
    },
    openAddBookmarkMeetingDialog() {
      let layoutCode = '';
      let fixSeatList = '';
      let pwdCode = '';

      // if (this.meeting.password !== null) {
      //   pwdCode = '8208=' + this.meeting.password + '&';
      // }
      if (this.conferenceRoomActive) {
        //고화질 영상회의 체크 됐을 때
      } else {
        if (this.layoutFixSeatList.selectedLayoutCode !== null) {
          layoutCode =
            '4192=0,' +
            this.layoutFixSeatList.selectedLayoutCode.replace('lay', '') +
            ',0&';
          fixSeatList = '';

          if (
            this.layoutFixSeatList.fixSeatList &&
            this.layoutFixSeatList.fixSeatList.length > 0
          ) {
            fixSeatList += '8304=';
            const seats = this.layoutFixSeatList.fixSeatList
              .filter((fixSeat) => fixSeat.seat !== null)
              .map((fixSeat) => {
                return (
                  fixSeat.id +
                  ',1,' +
                  fixSeat.seat.split('_')[0] +
                  ',' +
                  fixSeat.seat.split('_')[1]
                );
              });
            fixSeatList += seats.join('|');
          }
        }
      }

      let roomOption = pwdCode + layoutCode + fixSeatList;

      let meetingInfo = {
        creator: {
          email: this.meeting.email,
        },
        title: this.meeting.title,
        startDtime: this.meeting.startDtime, // (new Date(this.meeting.startTime)).toISOString().split('.')[0] + 'Z',
        endDtime: this.meeting.endDtime, // (new Date(this.meeting.endTime)).toISOString().split('.')[0] + 'Z',
        attendees: this.meeting.attendees,
        password: this.meeting.password,
        isImmediately: this.immediateMeeting,
        conferenceRoomActive: this.conferenceRoomActive,
        selectedConferenceRoomArr: this.selectedConferenceRoomArr,
        layoutFixSeatList: this.layoutFixSeatList,
        meetingLog: this.meetingLog,
        roomOption: roomOption,
      };

      this.addBookmarkMeetingDialog.dialog = true;
      this.addBookmarkMeetingDialog.meetingInfo = meetingInfo;
    },
    closeAddBookmarkMeetingDialog() {
      this.addBookmarkMeetingDialog.dialog = false;
    },
    closeGuideLogDialog(contents) {
      if (contents) {
        this.guideLogContents = contents;
      } else {
        // 취소
        this.guideLogContents = contents;
        this.guideLog = false;
      }
      this.guideLogDialog.dialog = false;
    },
    closeRecLogDialog(contents) {
      if (contents) {
        this.recLogContents = contents;
      } else {
        // 취소
        this.recLogContents = contents;
        this.recLog = false;
      }
      this.recLogDialog.dialog = false;
    },
    openMeetingInvitaionDialog() {
      this.meetingInvitaionDialog.dialog = true;
      this.meetingInvitaionDialog.attendees = this.meeting.attendees;
    },
    closeMeetingInvitaionDialog(attendees, exMeeting) {
      if (attendees) {
        if (attendees.length === 1) {
          if (attendees[0].name) {
            this.attendeesString = `${attendees[0].name}`;
          } else if (attendees[0].email) {
            this.attendeesString = `${attendees[0].email}`;
          } else {
            this.attendeesString = `${attendees[0].phone}`;
          }
        } else if (attendees.length > 1) {
          if (attendees[0].name) {
            this.attendeesString = `${attendees[0].name} 외 ${attendees.length -
              1}명`;
          } else if (attendees[0].email) {
            this.attendeesString = `${
              attendees[0].email
            } 외 ${attendees.length - 1}명`;
          } else {
            this.attendeesString = `${
              attendees[0].phone
            } 외 ${attendees.length - 1}명`;
          }
        } else if (attendees.length === 0) {
          this.attendeesString = null;
        }

        this.meetingInvitaionDialog.dialog = false;
        this.meeting.attendees = attendees;
        this.exMeeting = exMeeting;
      } else {
        this.meetingInvitaionDialog.dialog = false;
        this.meetingInvitaionDialog.attendees = attendees;
        this.meeting.attendees = attendees;
      }
    },
    openMeetingLayoutDialog() {
      /* 레이아웃 설정 */

      if (this.meeting.attendees !== undefined) {
        this.meeting.attendees.forEach((el) => {
          if (!el.name) {
            el['name'] = el.email;
          }
        });
        this.meetingLayoutDialog.attendees = this.meeting.attendees;

        this.meetingLayoutDialog.fixSeatList = this.layoutFixSeatList.fixSeatList;
        if (
          this.conferenceRoomActive &&
          this.selectedConferenceRoomArr.length >= 1
        ) {
          if (this.selectedConferenceRoomArr[0] === undefined) {
            alert('영상회의실을 추가해주세요');
            return;
          }
          let concatData = this.selectedConferenceRoomArr.map((c) => {
            return {
              email: c._id,
              name: c.name,
            };
          });
          console.log(this.meetingLayoutDialog.attendees);
          if (this.meetingLayoutDialog.attendees === undefined) {
            this.meetingLayoutDialog.attendees = [];
          }
          this.meetingLayoutDialog.attendees = this.meetingLayoutDialog.attendees.concat(
            concatData
          );
        }

        this.meetingLayoutDialog.dialog = true;
      } else {
        if (
          this.conferenceRoomActive &&
          this.selectedConferenceRoomArr.length >= 1
        ) {
          this.meetingLayoutDialog.attendees = [];
          if (this.selectedConferenceRoomArr[0] === undefined) {
            alert('영상회의실을 추가해주세요');
            return;
          }
          let concatData = this.selectedConferenceRoomArr.map((c) => {
            return {
              email: c.deviceId,
              name: c.deviceName,
            };
          });
          console.log(this.meetingLayoutDialog.attendees);
          if (this.meetingLayoutDialog.attendees === undefined) {
            this.meetingLayoutDialog.attendees = [];
          }
          this.meetingLayoutDialog.attendees = this.meetingLayoutDialog.attendees.concat(
            concatData
          );
        }
        this.meetingLayoutDialog.dialog = true;
      }
    },
    closeMeetingLayoutDialog() {
      this.meetingLayoutDialog.dialog = false;
    },
    selectedFixSeatList(selectedLayoutCode, selectedLayoutImage, fixSeatList) {
      /* @emit function */
      let fixSeatCount = 0;
      for (let k = 0; k < fixSeatList.length; k++) {
        if (fixSeatList[k].seat !== null) {
          console.log(fixSeatList[k].seat);
          fixSeatCount++;
        }
      }

      this.isLayout = '';
      this.isInputLayout = 'none';
      this.layoutFixSeatList.selectedLayoutCode = selectedLayoutCode;
      this.layoutFixSeatList.selectedLayoutImage = selectedLayoutImage;

      if (fixSeatCount > 0) {
        this.layoutFixSeatList.fixSeatList = fixSeatList;
      }
      this.meetingLayoutDialog.selectLayoutCode = selectedLayoutCode;
      if (this.layoutFixSeatList.selectedLayoutCode === null) {
        this.isInputLayout = '';
        this.isLayout = 'none';
      }

      this.closeMeetingLayoutDialog();
    },
    selectMeetingBookmark() {
      if (this.meetingBookmarkActive === false) {
        this.meetingBookmarkActive = true;
        this.meetingBookmarkImage = '/static/seoul/img/bookmark_on.png';
      } else {
        this.meetingBookmarkActive = false;
        this.meetingBookmarkImage = '/static/seoul/img/bookmark_off.png';
      }
    },
    selectedBookmarkMeeting(meeting) {
      /* 회의 제목 */
      this.meeting.title = meeting.title;

      console.log(`bookmarkmeeting : `, meeting);
      /* 공개 비공개 */
      if (meeting.meetingPW === null) {
        this.meetingPublicType = false;
        this.isPrivate = 'none';
        this.meeting.password = '';
      } else {
        this.isPrivate = '';
        this.meetingPublicType = true;
        this.meeting.password = meeting.meetingPW;
      }

      /* 영상회의실 */
      this.conferenceRoomActive = meeting.conferenceRoomActive;

      /* 참석자 */
      this.attendeesString = meeting.attendeesString;
      this.meeting.attendees = meeting.attendees;

      /* 레이아웃 */
      if (meeting.layoutCode === null || meeting.layoutCode === undefined) {
        this.isLayout = 'none';
        this.isInputLayout = '';
      } else {
        this.isLayout = '';
        this.isInputLayout = 'none';
        this.layoutFixSeatList.layoutCode = meeting.layoutCode;
        this.layoutFixSeatList.selectedLayoutImage = meeting.layoutImage;

        this.meetingLayoutDialog.attendees = meeting.attendees;
        this.layoutFixSeatList.fixSeatList = meeting.fixSeatList;
        this.layoutFixSeatList.selectedLayoutCode = meeting.layoutCode;
        this.meetingLayoutDialog.selectLayoutCode = meeting.layoutCode;
      }

      /* 회의록 */
      this.meetingLog = meeting.meetingLog;
      /* 여기서 작업 */
    },
    openHelpDialog() {
      this.isHelpActive = '';
    },
    closeHelpDialog() {
      this.isHelpActive = 'none';
    },
  },
};
</script>
<style scoped lang="stylus">
.pop_top{
  font-weight: 600;
}
.input_meeting{
  border:1px solid #d4d4d4;
  width: 100%;
  vertical-align: middle;
  height: 46px;
  display: inline-block;
  line-height: 2em;
  box-sizing: border-box;
  color: #4e4e4e;
  overflow: hidden;
  text-decoration: none;
  text-indent: 10px;
  border-radius:5px;
}

.datetime-start{
  width: 60%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}
.datetime-end{
  width: 39%;
  margin-left: 1%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}

.formbox-time-select{
  width: 24.5%;
  height: 40px;
  font-size:15px;
  font-weight: 300;
  border: 2px solid #ecedef;
  border-radius: 5px;
  padding-left: 18px;
  margin-left: 0px !important;
  line-height: 35px;

  background-position: 90% 52%;
  background-repeat: no-repeat, no-repeat;

  /* background: url(/static/webex-cloud/images/common/selar.png) no-repeat 87% 52%;
  background: url(/static/webex-cloud/images/common/selar.png) no-repeat 25% 52%; */
}
#startDate1 {
  max-width: 150px;
  margin-right : 15px;
}
.formbox-banner-select{
  width: 65px;
  height: 30px;
  font-size:15px;
  font-weight: 100;
  border: 2px solid #dadada;
  border-radius: 5px;
  padding-left: 7px;
  margin-left: 0px !important;
  line-height: 25px;
  background-image: url(/static/webex-cloud/images/common/selar.png);
  background-position: 87% 52%;
  background-repeat: no-repeat;
}


.select-items {
  position: absolute;
  background-color: DodgerBlue;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
}

.meeting-time{
  border: 1px solid #d4d4d4;
  width : 49%;
  height: 46px;
  float: left;
  text-align: center;
  line-height: 46px;
}

.tbw_p01 .active {
  display: '';
}

.tbw_p01 .noActive {
  display: none;
}

.conferenceroom-btn {
  width: max-content;
  padding-right: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 5px;
  margin-left: 10px;
  background: #fa4242;
  color: white;
  border-radius: 5px;
  z-index: 5;
  position: relative;
  float: left;
}

.conferenceroom-btn p{
  float: left;
  padding-left: 10px;
}
.conferenceroom-btn img{
  float: left;
  cursor: pointer;
  padding-top: 7px;
  padding-left: 3px;
  width: 8px;
}
.pop_tit{
  height: 20px;
  padding: 30px 0 10px;
  color: #444;
  text-align: left;
  letter-spacing: -1px;
  font-size: 25px;
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
}
.pop_close{
  position: absolute;
  top: 20px;
  right: 20px;
  display:inline-block;
  width:15px;
  height:15px;
  text-indent: -9999px;
  background: url(/static/webex-cloud/images/common/close_btn.png) center center no-repeat;
}

.popContainer {
  background: #fff;
  font-size: 16px;
  height: 520px;
}

.v-picker{
  position: absolute;
  z-index: 1000;
  top: 45px;
}

.fix-layout-img {
  cursor:pointer;
  margin-left: 25px;
  max-width: 100px;
}

#bookmarkMeeting{
  text-align: center;
  font-size: 11.5pt;
  height: 40px;
  line-height: 40px;
  font-weight: 700;
  float: right;
  background: #cbe9f8;
  color: #2f66aa;
  border-radius: 5px;
}

#bookmarkAddMeeting{
  width: 130px;
  text-align: center;
  padding: 0;
  font-size: 10pt;
  height: 40px;
  line-height: 40px;
  font-weight: 100;
  position: relative;
  top: -43px;
  left: 175px;
}

.help-bg{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.98;
  z-index: 999;
  overflow: auto;
  text-align: center;
}
.help-img{
  width: 100%;
  max-width: 720px;
  display: inline-block;
  position: relative;
  top: 7%;
}
.close-img{
  position: fixed;
  top: 8%;
  right: 10%;
  cursor: pointer;
  z-index: 1001;
}
input::placeholder{
  color: #bfc3c5;
  padding-left: 5px;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #bfc3c5 !important;
    font-size: 1rem !important;
}

.dialog-container {
  width: 100%;
}


#tbVideoMeetingCreateDialog .dialog-container {
  width: 630px;
}

#tbVideoMeetingCreateDialog .dialog-header {
  height: 60px;
  line-height: 60px;
}

#tbVideoMeetingCreateDialog .header-btn img {
  width: 30px;
}

.is-ipad {
  height: 10px !important;
}

#tbVideoMeetingCreateDialog .dialog-title {
  width: 22%;
}

#tbVideoMeetingCreateDialog .attendee-row {
  justify-content: start;
}

.dialog-date-contents {
  width: 78%;
  margin-left: 30px;
}

#tbVideoMeetingCreateDialog .mx-datepicker {
  width: 110px;
  margin-left: 5px;
  align-items: center;
}

.dialog-hr-line {
  width: 100%;
  margin: 15px 0;
}

.custom-radio:checked {
  background: #31a552;
}

.custom-label:before {
  background-color: white;
}

#organizationChart .popup_tel_wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#organizationChart {
  height: 750px;
}

#organizationChart .dialog-container {
  height: 100%;
}

.orga-container {
  margin: 0 20px;
  margin-bottom: 20px;
}

.orga-step1 {
  border: 1px solid #dddddd;
  width: 45%;
  height: 100%;
  border-radius: 5px;
  padding: 10px;
  overflow: auto;
  max-height: 300px;
}

.orga-step2 {
  width: 70%;
  margin-left: 20px;
  max-height: 300px;
  overflow: auto;
}

.add-orga {
  border: 1px solid #604af3;
  width: calc(100% - 40px);
  margin-left: 20px;
  height: 40px;
  color: #604af3;
  border-radius: 4px;
}

.orga-search_area {
  margin: 10px 20px;
}
.orga-step3 {
  margin: 10px 20px;
}

.orga-selected-member-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: auto;
  max-height: 200px;
}
.orga-selected-member {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  margin: 15px;
}

.popup_tel_wrap {
  font-size: 15px !important;
}

#tbVideoMeetingCreateDialog .dialog-contents input {
  border: 2px solid #dddddd;
  border-radius: 5px;
  padding: 10px;
  height: 40px;
  width: 100%;
  font-size:15px;
}

#tbVideoMeetingCreateDialog .dialog-hr-line {
  margin : 8px 0;
  margin-left: 10px;
}
#tbVideoMeetingCreateDialog .dialog-body {
  margin-top: 13px;
}

#tbVideoMeetingCreateDialog .select-input {
  height : 40px;
}

#tbVideoMeetingCreateDialog .dialog-row {
  min-height: 40px;
}

#tbVideoMeetingCreateDialog .dialog-footer {
  padding-bottom: 13px;
}


.conference-radio:checked + .conference-label:after {
  top: 19px;
}

.dialog-title {
  font-size:15px;
}

.styled-checkbox + label {
  font-size:15px;
}

.custom-radio + .custom-label {
  font-size:15px;
}

input::placeholder{
  font-size: 15px !important;
  font-weight: 300 !important;
}

.styled-checkbox:checked + label:after {
  position: absolute;
  left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/TbVideoMeetingCreateDialog.vue